import { render, staticRenderFns } from "./UpgradePlanSection.vue?vue&type=template&id=557a970d&scoped=true&"
import script from "./UpgradePlanSection.vue?vue&type=script&lang=js&"
export * from "./UpgradePlanSection.vue?vue&type=script&lang=js&"
import style0 from "./UpgradePlanSection.vue?vue&type=style&index=0&id=557a970d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557a970d",
  null
  
)

export default component.exports